// Importiere die Firestore-Datenbankinstanz und firebase (für Timestamp) aus der compat-Konfiguration
import { db, firebase } from './firebase-config.js';

const guestbookForm = document.getElementById('guestbook-form');
const guestbookEntriesList = document.getElementById('guestbook-entries');
// Die Collection-Referenz wird jetzt anders erstellt mit der compat API
const entriesCollectionRef = db.collection("guestbookEntries");

// Helper-Funktion, um HTML-Injection zu vermeiden
function escapeHTML(str) {
    if (typeof str !== 'string') return ''; // Sicherstellen, dass es ein String ist
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

// Funktion zum Formatieren des Timestamps
function formatTimestamp(timestamp) {
    if (!timestamp || !timestamp.toDate) {
        return 'Datum unbekannt'; // Fallback, falls Timestamp nicht korrekt ist
    }
    const date = timestamp.toDate(); // Konvertiere Firestore Timestamp zu JavaScript Date Objekt
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleDateString('de-DE', options); // Deutsches Datumsformat
}

// Funktion zum Hinzufügen eines Eintrags zum DOM
function addEntryToDOM(name, message, timestamp, id = null) {
    const entryElement = document.createElement('li');
    entryElement.setAttribute('data-id', id);

    const formattedTime = formatTimestamp(timestamp);

    entryElement.innerHTML = `
        <div class="entry-header">
            <strong>${escapeHTML(name)}</strong>
            <span class="entry-timestamp">${formattedTime}</span>
        </div>
        <div class="entry-message">${escapeHTML(message)}</div>`;
    guestbookEntriesList.appendChild(entryElement);
}

// Funktion zum Laden und Anzeigen der Einträge aus Firestore in Echtzeit
function loadAndListenForEntries() {
    entriesCollectionRef.orderBy("timestamp", "desc") // Neueste zuerst anzeigen
        .onSnapshot((querySnapshot) => {
            guestbookEntriesList.innerHTML = ''; // Bestehende Einträge löschen
            querySnapshot.forEach((doc) => {
                const entryData = doc.data();
                addEntryToDOM(entryData.name, entryData.message, entryData.timestamp, doc.id);
            });
        }, (error) => {
            console.error("Error fetching guestbook entries: ", error);
            // Hier könnte eine Fehlermeldung für den Benutzer angezeigt werden
        });
}

// Funktion zum Speichern eines neuen Eintrags in Firestore
async function saveNewEntryToFirestore(name, message) {
    try {
        const docRef = await entriesCollectionRef.add({
            name: name,
            message: message,
            timestamp: firebase.firestore.FieldValue.serverTimestamp() // Compat API für Timestamp
        });
        console.log("Document written with ID: ", docRef.id);
    } catch (e) {
        console.error("Error adding document: ", e);
        alert('Fehler beim Speichern des Eintrags. Bitte versuche es später erneut.');
    }
}

if (guestbookForm) {
    guestbookForm.addEventListener('submit', async function(event) {
        event.preventDefault();

        const nameInput = document.getElementById('name');
        const messageInput = document.getElementById('message');

        const name = nameInput.value.trim();
        const message = messageInput.value.trim();

        if (name && message) {
            await saveNewEntryToFirestore(name, message);
            guestbookForm.reset();
        } else {
            alert('Bitte füllen Sie sowohl den Namen als auch die Nachricht aus.');
        }
    });
}

// Einträge beim Laden der Seite laden und auf Änderungen lauschen
document.addEventListener('DOMContentLoaded', loadAndListenForEntries);